import { fromStringsToDateTime } from './utils-functions'
import { TESSERE } from '../settings/settings'

const sortNumerically = (a, b) =>
  a === b ? 0 : a === undefined ? 1 : b === undefined ? -1 : a - b
const sortAlphabetically = (a, b) => (a === b ? 0 : a > b ? 1 : -1)
const sortChronologically = (a, b) => new Date(a) - new Date(b)

const sortSfide = (a, b) => sortNumerically(a, b)
const sortGiornate = (a, b) => sortNumerically(a, b)
const sortCategorie = (a, b) => sortAlphabetically(a, b)
const sortCodiceSocieta = (a, b) => sortNumerically(a, b)
const sortCampionati = (a, b) => sortNumerically(a, b)
const sortStagioni = (a, b) => -sortAlphabetically(a, b)

const sortTessere = (a, b) => {
  const aOrder = TESSERE?.find(t => t.key === a)?.order || Infinity
  const bOrder = TESSERE?.find(t => t.key === b)?.order || Infinity
  return aOrder - bOrder
}

const sortGironi = (a, b, avulsaFirst = 1) =>
  a === b
    ? 0
    : (a === undefined && 1) ||
      (b === undefined && -1) ||
      (a === 'finali' && -1) ||
      (b === 'finali' && 1) ||
      (a === 'avulsa' && -avulsaFirst) ||
      (b === 'avulsa' && avulsaFirst) ||
      ((isNaN(+a) || isNaN(+b)) && sortAlphabetically(a, b)) ||
      sortNumerically(a, b)

const sortNumeriGara = (a, b) =>
  a === b
    ? 0
    : (isNaN(+a) &&
        isNaN(+b) &&
        (a?.[0] === b?.[0] && !isNaN(+a.slice(1)) && !isNaN(+b.slice(1))
          ? sortNumerically(a.slice(1), b.slice(1))
          : sortAlphabetically(a, b))) ||
      (isNaN(+a) && 1) ||
      (isNaN(+b) && -1) ||
      sortNumerically(a, b)

const sortDataOra = (aData, aOra, bData, bOra) =>
  aData === bData && aOra === bOra
    ? 0
    : ((!aData || !aOra) && 1) ||
      ((!bData || !bOra) && -1) ||
      fromStringsToDateTime(aData, aOra) - fromStringsToDateTime(bData, bOra)

const sortTabelloni = (aSquadre, bSquadre, aNome, bNome) =>
  sortNumerically(aSquadre, bSquadre) ||
  (!aNome && -1) ||
  (!bNome && 1) ||
  sortAlphabetically(aNome, bNome)

const sortCalendari = (a, b) =>
  sortCategorie(a.categoria, b.categoria) ||
  sortGironi(a.girone, b.girone) ||
  sortGiornate(a.giornata, b.giornata) ||
  sortNumeriGara(a.numeroGara, b.numeroGara)

const sortClassifiche = (a, b) =>
  sortCategorie(a.categoria, b.categoria) ||
  sortGironi(a.girone, b.girone) ||
  sortNumerically(a.ranking, b.ranking)

const sortVociRendiconto = (a, b) =>
  sortCampionati(a.indiceCampionato, b.indiceCampionato) ||
  sortCategorie(a.categoria, b.categoria) ||
  sortNumeriGara(a.numeroGara, b.numeroGara)

const sortAuto = (x, field, ascending = true) => {
  if (!x || !field) return x

  return [...x]?.sort((a, b) => {
    if (a[field] === undefined && b[field] === undefined) return 0
    if (a[field] === undefined) return 1
    if (b[field] === undefined) return -1
    if (a[field] === b[field]) return 0
    return a[field] > b[field] ? (ascending ? 1 : -1) : ascending ? -1 : 1
  })
}

export {
  sortNumerically,
  sortAlphabetically,
  sortChronologically,
  sortSfide,
  sortGiornate,
  sortCategorie,
  sortCodiceSocieta,
  sortCampionati,
  sortStagioni,
  sortGironi,
  sortNumeriGara,
  sortDataOra,
  sortTabelloni,
  sortCalendari,
  sortClassifiche,
  sortVociRendiconto,
  sortTessere,
  sortAuto,
}
